var _defs, _rect, _path, _path2, _rect2, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _circle, _circle2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _polyline, _line, _line2, _line3, _path0, _polyline2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurveyor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 557",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke-width: 13px;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n        stroke: #d1d3d4;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-width: 12px;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #d1d3d4;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 195,
    y: 513,
    width: 111,
    height: 38,
    rx: 4,
    ry: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m172.6667,476h155.3333v29.3333c0,3.4955-2.8379,6.3333-6.3333,6.3333h-142.6667c-3.4955,0-6.3333-2.8379-6.3333-6.3333v-29.3333h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m146.8333,355h205.6667c3.4035,0,6.1667,2.7632,6.1667,6.1667v106.8333c0,3.3115-2.6885,6-6,6h-205.6667c-3.3115,0-6-2.6885-6-6v-107.1667c0-3.2195,2.6138-5.8333,5.8333-5.8333Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 170.3333,
    y: 383.3333,
    width: 80.1667,
    height: 60
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 279.3333,
    cy: 385.1667,
    rx: 4.5,
    ry: 3.6196
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 304.4739,
    cy: 385.1667,
    rx: 4.5,
    ry: 3.6196
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 331.2073,
    cy: 385.1667,
    rx: 4.5,
    ry: 3.6196
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 331.5,
    cy: 413.3333,
    rx: 4.5,
    ry: 3.6196
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 306,
    cy: 414.5,
    rx: 4.5,
    ry: 3.6196
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 279.3333,
    cy: 414.5,
    rx: 4.5,
    ry: 3.6196
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 279.3333,
    cy: 443.3333,
    rx: 4.5,
    ry: 3.6196
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 304.4739,
    cy: 443.3333,
    rx: 4.5,
    ry: 3.6196
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 331.5,
    cy: 443.3333,
    rx: 4.5,
    ry: 3.6196
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 249.9167,
    cy: 233.9167,
    r: 27.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 249.9167,
    cy: 233.9167,
    r: 14.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m84.75,256.9167h22.25v60.5833h-22.25c-3.7254,0-6.75-3.0246-6.75-6.75v-47.0833c0-3.7254,3.0246-6.75,6.75-6.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m401.25,318.7083h22.25v60.5833h-22.25c-3.7254,0-6.75-3.0246-6.75-6.75v-47.0833c0-3.7254,3.0246-6.75,6.75-6.75Z",
    transform: "translate(818 698) rotate(180)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m99.5,370.5c-.3464,8.1394-.8379,16.2884-1.0791,24.4296-.155,5.2308.7429,10.4284,2.9741,15.1852,3.0438,6.4892,8.6925,11.5719,15.4497,13.9722,6.7516,2.3983,14.1392,1.5809,21.1552,1.5325,9.6485-.0665,9.6702-15.0667,0-15-9.2458.0638-21.1315,1.8995-24.0504-9.6359-.5913-2.3367-.5662-4.5762-.4496-6.9837.3791-7.8308.6667-15.6671,1-23.5.4107-9.652-14.5901-9.6326-15,0h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m385,301.5c0,32.019-.3682,64.0593,0,96.0758.0393,3.4194.0415,6.7347-3.511,8.5502-.6339.324-3.5298.8564-1.6735.6782-1.989.1909-4.0464.0347-6.0473.0621-3.7568.0516-7.5106.1285-11.2682.1336-9.6512.0132-9.6683,15.0132,0,15,6.6775-.0091,14.3566.8042,20.8724-.7297,9.1129-2.1452,15.7896-9.8795,16.5713-19.2047.4297-5.1258.0563-10.4594.0563-15.6003v-84.9654c0-9.6518-15-9.6678-15,0h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m221.6667,179c18.6667,0,37.3333,0,56,0,9.6518,0,9.6678-15,0-15-18.6667,0-37.3333,0-56,0-9.6518,0-9.6678,15,0,15h0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m130.9401,246c14,0,28,0,42,0,9.6518,0,9.6678-15,0-15-14,0-28,0-42,0-9.6518,0-9.6678,15,0,15h0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m327.4401,246c14,0,28,0,42,0,9.6518,0,9.6678-15,0-15-14,0-28,0-42,0-9.6518,0-9.6678,15,0,15h0Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "304.4739 352 304.4739 168.5 304.4739 157 296 153.5 295.5 138 202 138 202 157 195.5 168.5 195.5 355"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 195.5,
    y1: 321.7083,
    x2: 304.4739,
    y2: 321.7083
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 308.0006,
    y1: 168.9222,
    x2: 382,
    y2: 169.4704
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 120,
    y1: 167.5296,
    x2: 192.9995,
    y2: 168.0704
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m114.5,342.5c.9039-30.7332,1.8078-61.4664,2.7118-92.1996.2716-9.2353-.0036-18.6788.9228-27.8766,1.6713-16.5931,4.145-33.1426,6.2147-49.6912,1.729-13.8244,3.8792-27.6959,5.8667-41.6153.7769-5.4409,1.5538-10.8818,2.3306-16.3226.8006-5.6069,2.7724-10.6049,4.6855-15.9258,4-11.125,8-22.25,12-33.375l-7.2321,5.5062c72.1667.3333,144.3333.6667,216.5,1-2.4107-1.8354-4.8214-3.6708-7.2321-5.5062,4.9489,14.1097,9.8979,28.2194,14.8468,42.3291,2.5656,7.3147,5.1312,14.6295,7.6969,21.9442.23.6558.3946,1.7328.8072,2.3014.8696,1.1984-.0439-2.5717-.0876-1.145-.0818,2.6708.4041,5.484.6001,8.1448,1.0237,13.8936,1.691,27.8619,3.1649,41.7163,1.5692,14.7505,3.6154,29.5289,4.7083,44.3215,1.1756,15.9122,1.3722,31.9517,2.0568,47.8939.413,9.6162,15.4152,9.6679,15,0-.652-15.1815-1.304-30.3631-1.9559-45.5446-.6057-14.1047-2.8505-28.2589-4.3435-42.2934-1.4183-13.3316-2.2033-26.7233-3.1884-40.093-.3991-5.4157-.0824-11.5383-1.4375-16.8367-1.5018-5.8719-4.0903-11.6616-6.0944-17.3754-5.7699-16.4502-11.5397-32.9005-17.3096-49.3507-1.1078-3.1585-3.7678-5.4902-7.2321-5.5062-72.1667-.3333-144.3333-.6667-216.5-1-3.5037-.0162-6.1072,2.3777-7.2321,5.5062-3.5556,9.8889-7.1111,19.7778-10.6667,29.6667-1.5529,4.319-3.2595,8.6109-4.6667,12.9792-1.6574,5.1451-1.958,10.8978-2.7231,16.2565-2.2864,16.0131-4.7821,32.0124-6.8286,48.0579-2.1178,16.605-4.1548,33.2206-6.2321,49.8307-1.0269,8.2105-.9821,16.4697-1.2253,24.7402-.5747,19.5415-1.1495,39.083-1.7242,58.6245-.4004,13.6128-.8008,27.2255-1.2011,40.8383-.284,9.6557,14.7163,9.6471,15,0h0Z"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "167 164 163.5 151 165.25 94.5 336.5 94.5 336.5 146 329.5 164"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyor);
export default __webpack_public_path__ + "static/media/surveyor.8c800c7bb30598f8328ce073c0b11e80.svg";
export { ForwardRef as ReactComponent };